// styles.ts
import styled from "styled-components";

/**
 * Container do aviso mostrado no lugar dos resultados quando a busca não pode
 * ou não conseguiu ser feita.
 */
export const StyledSearchErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 320px;
  gap: 16px;
  padding: 24px 16px;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
